import { useQuery } from 'react-query';

import { getPestsVsTracesChart } from 'api/analitics/EncCharts/getPestsVsTracesChart';

export const useGetPestsVsTracesChart = (slug: string, start_date: string, end_date: string) => {
  return useQuery(
    ['pestsVsTracesChart', slug, start_date, end_date],
    () => getPestsVsTracesChart(slug, start_date, end_date),
    {
      enabled: Boolean(slug && start_date && end_date),
      refetchOnWindowFocus: false,
    },
  );
};
